<template>
  <div class="replenishment">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="手机号" prop="mobile" :rules="rulesUtils.checkPhone">
        <el-input
          placeholder="请输入手机号"
          v-model="ruleForm.mobile"
          maxlength="11"
        >
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="患者姓名" prop="patientName">
        <el-input
          placeholder="请输入患者姓名"
          v-model="ruleForm.patientName"
          onkeyup="value=value.replace(/[\d]/g,'') "
          onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[\d]/g,''))"
        ></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >下一步</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="用户信息"
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <el-form
        :model="userForm"
        :rules="userRules"
        ref="userForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="手机号" prop="mobile">
          {{ userForm.mobile }}
        </el-form-item>
        <el-form-item label="患者姓">
          <!-- <el-input
            placeholder="请输入患者姓名"
            v-model="userForm.patientName"
            onkeyup="value=value.replace(/[\d]/g,'') "
            onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[\d]/g,''))"
          ></el-input> -->
          <el-col :span="4">
            <el-form-item prop="familyName">
              <el-input
                placeholder="姓"
                v-model="userForm.familyName"
                onkeyup="value=value.replace(/[\d]/g,'') "
                onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[\d]/g,''))"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2" style="margin-left:10px">名</el-col>
          <el-col :span="16">
            <el-form-item prop="firstName">
              <el-input
                placeholder="请输入名"
                v-model="userForm.firstName"
                onkeyup="value=value.replace(/[\d]/g,'') "
                onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[\d]/g,''))"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="性别" prop="patientGender">
          <el-radio-group v-model="userForm.patientGender">
            <el-radio label="10901">男</el-radio>
            <el-radio label="10902">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证件类型" prop="patientCardType">
          <el-select
            v-model="userForm.patientCardType"
            placeholder="请选择证件类型"
            @change="handelChangeDate"
          >
            <el-option label="身份证" :value="10401"></el-option>
            <el-option label="护照" :value="10402"></el-option>
            <el-option label="港澳通信证" :value="10403"></el-option>
            <!-- <el-option label="其它" :value="10400"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="patientCardNo">
          <el-input
            placeholder="请输入证件号码"
            v-model="userForm.patientCardNo"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="年龄"
          prop="patientAge"
          :rules="[
            { required: true, message: '年龄不能为空' },
            { type: 'number', message: '年龄必须为数字值' },
          ]"
        >
          <el-input
            type="age"
            placeholder="请输入年龄"
            v-model.number="userForm.patientAge"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="showDate" label="出生年月" required>
          <el-form-item prop="patientBirthdate">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="userForm.patientBirthdate"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item label="主诉" prop="described">
          <el-input
            placeholder="请输入主诉内容"
            type="textarea"
            v-model="userForm.described"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary">下一步</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetUserForm('userForm')">取 消</el-button>
        <el-button type="primary" @click="saveHisCaseSupplement('userForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { saveHisCaseSupplement, savePhone } from "@/api/doctor";
import rules from "@/utils/rules";

export default {
  name: "replenishment",
  data() {
    return {
      dialogVisible: false,
      show: true,
      ruleForm: {
        mobile: "",
        channelId: "5",
      },
      rulesUtils: rules, // 身份证号和手机号校验
      userForm: {
        mobile: "",
        familyName: '',
        firstName: '',
        patientAge: "",
        patientCardNo: "",
        patientCardType: "",
        patientGender: "",
        channelId: "5",
        described: "",
        orderNo: "",
      },
      userRules: {
        patientBirthdate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        // patientName: [
        //   { required: true, message: "请输入患者姓名", trigger: "blur" },
        // ],
        familyName: [
          { required: true, message: "请输入患者姓", trigger: "blur" },
        ],
        firstName: [
          { required: true, message: "请输入患者名", trigger: "blur" },
        ],
        patientAge: [
          { required: true, message: "请输入年龄", trigger: "blur" },
        ],
        patientCardNo: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
        ],
        patientCardType: [
          {
            required: true,
            message: "请至少选择一个证件类型",
            trigger: "change",
          },
        ],
        patientGender: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        described: [
          { required: true, message: "请填写主诉内容", trigger: "blur" },
        ],
      },
      // 药品部分
      patientInfo: {
        drugsList: [],
      },
      sickInfo: {
        caseContent_dictText: {},
      },
      drugShow: false, // 添加药品
      patientInfo: {
        drugsList: [],
      },
      drugs: [],
      userInfo: {},
      count: "",
      showDate: false,
    };
  },
  methods: {
    handelChangeDate() {
      if (this.userForm.patientCardType != 10401) {
        this.showDate = true;
      } else {
        this.showDate = false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.$confirm("请确认手机号是否填写正确", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            const { code, data } = await savePhone(this.ruleForm);
            if (code == 1) {
              this.userForm.mobile = data.mobile;
              this.userForm.orderNo = data.orderNo;
              this.userForm.patientName = this.ruleForm.patientName;
              this.dialogVisible = true;
              // this.userInfo = data;
              // const query = {
              //   sessionId: "p2p-" + 1111111,
              //   treatId: data.orderNo,
              //   patientId: data.patientId,
              //   status: 10002,
              //   type: "replenishment",
              // };
              // this.$router.push({
              //   path: "/index/work/chart",
              //   query,
              // });
            }
          });
        }
      });
    },
    // 更新用户信息
    saveHisCaseSupplement(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          if (
            !reg.test(this.userForm.patientCardNo) &&
            this.userForm.patientCardType === 10401
          ) {
            return this.$message.error("证件号码不正确");
          }
          const { code, data } = await saveHisCaseSupplement(this.userForm);
          if (code == 1) {
            this.userInfo = data;
            const query = {
              sessionId: "p2p-" + 1111111,
              treatId: data.orderNo,
              patientId: data.patientId,
              status: 10002,
              type: "replenishment",
              memberId: data.memberId,
            };
            this.$router.push({
              path: "/index/work/chart",
              query,
            });
          }
        }
      });
    },
    resetUserForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.replenishment {
  width: 30%;
  margin: auto;
  margin-top: 5%;
}
/deep/ .el-input-group__append {
  left: 5px;
  border-left: 1px solid #dcdfe6;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  button.el-button {
    background-color: #66b1ff;
    color: #fff;
    border: 1px solid #66b1ff;
  }
}
</style>
